<template>
  <span
    class="campaign-disclosure-tooltip-span"
    data-toggle="tooltip"
    data-html="true"
    :title="addisclosureText"
  >
    {{ addisclosureTitle }}  
  </span>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
import constants from '../common/constants'

export default defineComponent({    
  components: {    
  },
  mounted() {
    (jQuery(".campaign-disclosure-tooltip-span") as any).tooltip({
      template:
        '<div class="tooltip da-tooltip da-tooltip-white campaign-disclosure-tooltip" role="tooltip"><div class="arrow tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      container: "body",
      placement: "bottom",
      html: true,
    });
  },
  props: {
    lendingTreeMode: {
      default: false
    }
  },  
  data() {
    if (this.lendingTreeMode) {
      var title = constants.AD_DISCLOSURE_TITLE;
      var content = constants.LT_DISCLOSURE_CONTENT.replace('[dateNow]', new Date().toLocaleDateString());
    }
    else {
      var title = constants.AD_DISCLOSURE_TITLE;
      var content = constants.AD_DISCLOSURE_CONTENT.replace('[dateNow]', new Date().toLocaleDateString());
    }    
    return {    
      addisclosureTitle: title,
      addisclosureText: content     
    };
  },
})
</script>
<style lang="scss" scoped>
.campaign-disclosure-tooltip-span:hover{
  cursor: default;
}
.tooltip.da-tooltip.show {
  opacity: 1;
}
.da-tooltip-white > .tooltip-inner {
  background-color: #fff !important;
  color: #555;
  font-size: 13px;
  text-align: left;
  font-weight: 400;
  border: 1px solid #ccc;
  font-style: italic;
}
.info-icon {
  color: #c6c4c7;
}

/* Bootstrap 3 tooltip styles */
.da-tooltip > .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
  border: none !important;
}
.tooltip.bottom {
  padding: 0.4rem 0;
}

/* Bootstrap 3 styles */
.da-tooltip > .tooltip-arrow::before,
.da-tooltip > .tooltip-arrow::after {
  content: "";
  position: absolute;
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-color: transparent;
  border-style: solid;
}

/* Bootstrap 3 and 4 tooltip styles */
.da-tooltip > .tooltip-arrow::before {
  border-bottom-color: #ccc !important;
  border-top-color: #ccc !important;
}
.da-tooltip > .tooltip-arrow:after {
  transform: translateY(3px);
  border-bottom-color: #fff !important;
  border-top-color: #fff !important;
}

/* Bootstrap 4 tooltip styles */
.bs-tooltip-top > .arrow::before,
.bs-tooltip-top > .arrow::after {
  border-width: 0.4rem 0.4rem 0 !important;
}
.bs-tooltip-bottom > .arrow::before,
.bs-tooltip-bottom > .arrow::after {
  border-width: 0 0.4rem 0.4rem !important;
}
.bs-tooltip-top > .arrow::after {
  transform: translateY(-3px);
}
</style>
<style lang="scss">
.campaign-disclosure-tooltip {
  .tooltip-inner {
    max-width: 400px;
    //width: 400px;
    text-align: left !important;
    font-size: 13px;
    span {
      color: #4699bb;
    }
  }
}
@media (min-width:301px) and (max-width:400px){
  .campaign-disclosure-tooltip {
      width: 300px;
  }
}
@media (max-width:300px){
  .campaign-disclosure-tooltip {
      width: 250px;
  }
}
</style>